export const selectOneArtist = (state) => state.allArtist.artist;
